import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  LinearProgress,
  Typography,
} from "@mui/material"
import type { ChatAnalyze } from "../interfaces"

interface ReactionsSectionProps {
  stats: ChatAnalyze.Stats
}

export function ReactionsSection({ stats }: ReactionsSectionProps) {
  const {
    totalReactions,
    msgsWithReactions,
    reactionCoverage,
    reactionRate,
    reactorUsersCount,
    reactionCounter,
  } = stats

  const sortedEmojis = Object.entries(reactionCounter)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 10)

  const topCount = sortedEmojis[0]?.[1] ?? 1

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
        gap: 3,
      }}
    >
      {/* Статистика реакций */}
      <Box>
        <TableContainer>
          <Table size="small">
            <TableBody>
              {[
                {
                  label: "Сообщений с реакциями",
                  value: `${msgsWithReactions.toLocaleString("ru-RU")} (${reactionCoverage.toFixed(1)}%)`,
                },
                {
                  label: "Всего реакций",
                  value: totalReactions.toLocaleString("ru-RU"),
                },
                {
                  label: "Среднее реакций/сообщение (ER)",
                  value: <strong>{reactionRate.toFixed(3)}</strong>,
                },
                {
                  label: "Уникальных реагировавших",
                  value: reactorUsersCount.toLocaleString("ru-RU"),
                },
              ].map((row) => (
                <TableRow
                  key={row.label}
                  sx={{ "&:last-child td": { border: 0 } }}
                >
                  <TableCell sx={{ color: "text.secondary" }}>
                    {row.label}
                  </TableCell>
                  <TableCell>{row.value}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Топ эмодзи */}
      <Box>
        {sortedEmojis.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            Реакций не найдено
          </Typography>
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700 }}>Эмодзи</TableCell>
                  <TableCell sx={{ fontWeight: 700 }} align="right">
                    Кол-во
                  </TableCell>
                  <TableCell sx={{ fontWeight: 700, minWidth: 120 }}>
                    Доля
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedEmojis.map(([emoji, count]) => (
                  <TableRow
                    key={emoji}
                    sx={{ "&:last-child td": { border: 0 } }}
                  >
                    <TableCell sx={{ fontSize: "1.3em" }}>{emoji}</TableCell>
                    <TableCell align="right">
                      <strong>{count.toLocaleString("ru-RU")}</strong>
                    </TableCell>
                    <TableCell>
                      <LinearProgress
                        variant="determinate"
                        value={(count / topCount) * 100}
                        color="secondary"
                        sx={{ height: 6, borderRadius: 1 }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </Box>
  )
}
